// eslint-disable

import Vue from 'vue'
// Import one of available themes
// import 'vue-toast-notification/dist/theme-default.css'
import 'vue-toast-notification/dist/theme-sugar.css'

const VueToast = require('vue-toast-notification')

Vue.use(VueToast, { position: 'top', duration: 3000 })

interface ToastOptions {
  message?: string
  type?: string
  position?: string
  duration?: number
  dismissible?: boolean
  onClick?: () => void
  onClose?: () => void
  queue?: boolean
  pauseOnHover?: boolean
}

interface Toast {
  info: (message: string, options?: ToastOptions) => Toast
  warning: (message: string, options?: ToastOptions) => Toast
  error: (message: string, options?: ToastOptions) => Toast
  default: (message: string, options?: ToastOptions) => Toast
  success: (message: string, options?: ToastOptions) => Toast
  close: () => void
}

declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    toast?: Toast
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $toast: Toast
  }
}
